import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutMe.css';

const AboutMe: React.FC = () => {
  useEffect(() => {
    document.title = 'About Me | Sourov Roy';
  }, []);

  return (
    <div className="about-me">
      <div className="about-me-container">
        <div className="about-me-content">
          <div className="about-me-text">
            <h1 className="about-me-title">About Me</h1>
            <div className="about-me-bio">
              <p>
                Hello, I'm Sourov Roy, a Software Engineer with over five years of experience designing and building scalable systems at <strong>Amazon</strong>, <strong>Deliveroo</strong>, <strong>DoorDash</strong>, and <strong>Salesforce</strong>.
              </p>
              <p>
                I graduated in <strong>Computer Science & Engineering</strong> from <strong>Jadavpur University</strong> in 2020.
              </p>
              <p>
                I’m deeply passionate about distributed systems and machine learning, with a strong foundation in algorithms, system design, and large-scale architecture. I enjoy solving complex engineering challenges that make technology more efficient and reliable.
              </p>
              <p>
                Outside of work, I write about technology, nature, finance, and humanities. 
                Feel free to explore my <Link to="/blog" className="blog-link">blogs</Link> to learn more about my interests and ideas, 
                and don't hesitate to reach out to me on <a href="https://www.linkedin.com/in/sourovroy-ai/" target="_blank" rel="noopener noreferrer" className="linkedin-link">LinkedIn</a> if you'd like to connect.
              </p>
            </div>
            
            <div className="about-me-highlights">
              <div className="highlight-item">
                <h3>Current Role</h3>
                <p>Senior Member of Technical Staff at Salesforce</p>
              </div>
              <div className="highlight-item">
                <h3>Experience</h3>
                <p>5+ years in software engineering</p>
              </div>
              <div className="highlight-item">
                <h3>Mentoring</h3>
                <p>8+ years in mentoring</p>
              </div>
              <div className="highlight-item">
                <h3>Education</h3>
                <p>BE in Computer Science & Engineering from Jadavpur University</p>
              </div>
              <div className="highlight-item">
                <h3>Location</h3>
                <p>Hyderabad, India</p>
              </div>
            </div>

            <div className="about-me-skills">
              <h3>Key Expertise</h3>
              <div className="skills-tags">
                <span className="skill-tag">Distributed Systems</span>
                <span className="skill-tag">AWS</span>
                <span className="skill-tag">Java</span>
                <span className="skill-tag">Golang</span>
                <span className="skill-tag">Python</span>
                <span className="skill-tag">React</span>
                <span className="skill-tag">Machine Learning</span>
              </div>
            </div>
          </div>
          
          <div className="about-me-image">
            <img src="/static/me.jpeg" alt="Sourov Roy" className="profile-image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
